export enum SyncModeEnum {
  Full,
  Manual,
}
